<script setup lang="ts">
  const props = defineProps<{
    href: string
    bgImageSrc?: string
    title: string
    description: string
  }>()

  const bgStyle = computed(() => {
    if (!props.bgImageSrc) {
      return ''
    }
    return {
      backgroundImage: `url('${props.bgImageSrc}')`
    }
  })
</script>
<template>
  <NuxtLink
    :to="href"
    :aria-label="title"
    external
    class="overflow-hidden rounded-sm no-underline"
  >
    <div
      class="h-48 bg-cover bg-center"
      :style="bgStyle"
    />
    <div class="h-full bg-bt-light-gray px-6 pb-8 pt-6">
      <p class="mb-4 text-bt-blue-dark text-subtitle-1">{{ title }}</p>
      <p class="text-bt-blue-dark text-body-2">{{ description }}</p>
    </div>
  </NuxtLink>
</template>
